module.exports = __webpack_public_path__ + "img/comodin-002.f397c456.svg";